import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import dayjs from "dayjs";

interface TableState {
  currentPage: number;
  rowsPerPage: number;
  searchTerm: string;
  dateRange: [string | null, string | null];
  selectedRows: string[];
}


const initialState: TableState = {
  currentPage: 1,
  rowsPerPage: 25,
  searchTerm: "",
  dateRange: [
    dayjs().subtract(7, "day").format("YYYY-MM-DD"),
    dayjs().format("YYYY-MM-DD"),
  ],
  selectedRows: [],
};


const tableSlice = createSlice({
  name: "ApproverruleTable",
  initialState,
  reducers: {
    setPage: (state, action: PayloadAction<number>) => {
      state.currentPage = action.payload;
    },
    setRowsPerPage: (state, action: PayloadAction<number>) => {
      state.rowsPerPage = action.payload;
    },
    setSearchTerm: (state, action: PayloadAction<string>) => {
      state.searchTerm = action.payload;
    },
    setDateRange: (
      state,
      action: PayloadAction<[string | null, string | null]>
    ) => {
      state.dateRange = action.payload;
    },
    setSelectedRows: (state, action: PayloadAction<string[]>) => {
      state.selectedRows = action.payload;
    },
    resetTableState: () => initialState,
  },
});

export const {
  setPage,
  setRowsPerPage,
  setSearchTerm,
  setDateRange,
  setSelectedRows,
  resetTableState,
} = tableSlice.actions;

export default tableSlice.reducer;